import jsPDF from 'jspdf'
import intl from 'react-intl-universal'
import helpers from '../../../utils/helpers'
import iconLogo from './icon-logo.png'


class PDFGenerator {
    constructor() {

        this.filename = intl.get('report.report') + '.pdf'

        this.colors = {
            black: "#000000",
            gray: "#53565a",
            mediumGray: "#898A84",
            lightgray: "#DDDDD9",
            green: "#679B8F",
            lightGreen: "#B3C9C4",
        }

        this.margin = 10
    }

    setParams(absorbantRooms, roomWidth, roomHeight, roomDepth, ceilingMaterial, wallMaterial, floorMaterial) {
        this.absorbantRooms = absorbantRooms
        this.roomWidth = roomWidth
        this.roomHeight = roomHeight
        this.roomDepth = roomDepth
        this.ceilingMaterial = ceilingMaterial
        this.wallMaterial = wallMaterial
        this.floorMaterial = floorMaterial
    }


    start() {

        this.doc = new jsPDF()

        const doc = this.doc

        doc.addImage(iconLogo, 'PNG', 105-21, 277, 42, 4.6)

        let nbrOfRooms = 2
        if (this.absorbantRooms.length > 2
            && helpers.atLeastOneProductActiveForRoom(this.absorbantRooms[2])) {
                nbrOfRooms = 3
        }

        let currentY = 0

        doc.setLineHeightFactor(1.5)
        doc.setFont("helvetica")

        currentY += 20
        doc.setTextColor(this.colors.black)
        doc.setFontStyle("bold")
        doc.setFontSize(21)
        doc.text(intl.get('report.report'), this.margin, currentY)

        currentY += 10
        doc.setTextColor("#53565a")
        doc.setFontStyle("normal")
        doc.setFontSize(10)
        doc.text(doc.splitTextToSize(intl.get('report.description'), 170), this.margin, currentY)

        const wallIterator = this.absorbantRooms[0].absorbantWalls

        wallIterator.forEach((wall, wallIndex) => {

            let wallWidth = this.roomWidth
            const wallHeight = this.roomHeight
            if (wall.description === "right"
                || wall.description === "left") {
                    wallWidth = this.roomDepth
            }

            const wallArea = wallWidth * wallHeight

            // Any product for any room for this wall?
            let isCompact = true
            for (let i=0; i<nbrOfRooms; i++) {
                const absorbantRoom = this.absorbantRooms[i]
                absorbantRoom.absorbantWalls[wallIndex].layerOne.product && (isCompact = false)
            }
            let boxHeight = 74
            isCompact && (boxHeight = 46)
            if (currentY > 297 - boxHeight - 20) {
                doc.addPage()
                currentY = 20
                doc.addImage(iconLogo, 'PNG', 105-21, 277, 42, 4.6)
            }

            wallIndex === 0 && (currentY += 30)
            // wallIndex > 0 && (currentY += 95)
            doc.setTextColor(this.colors.black)
            doc.setFontStyle("bold")
            doc.setFontSize(11)
            doc.text(intl.get('textiles.wall', {name: wall.name}), this.margin, currentY)

            const wallDimensions = helpers.getNumberString(wallWidth, 2) + " x " + helpers.getNumberString(wallHeight, 2) + " m, " + intl.get('general.squareMeter', { area: helpers.getNumberString(wallWidth * wallHeight, 2) })
            doc.setTextColor(this.colors.gray)
            doc.setFontStyle("normal")
            doc.setFontSize(10)
            doc.text(wallDimensions, 210-this.margin, currentY, null, null, "right")

            currentY += 5

            for (let i=0; i<nbrOfRooms; i++) {
                const absorbantRoom = this.absorbantRooms[i]
                const marginLeft = this.margin + i * (210-2*this.margin) / nbrOfRooms
                const layer = absorbantRoom.absorbantWalls[wallIndex].layerOne
                this.box(helpers.getRoomName(absorbantRoom), wallArea, this.wallMaterial, layer, marginLeft, currentY, (210-2*this.margin) / nbrOfRooms, boxHeight, isCompact)
            }

            isCompact ? currentY += 61 : currentY += 90

        })

        let boxHeight = 46

        // Floor
        if (currentY > 297 - boxHeight - 20) {
            doc.addPage()
            currentY = 20
            doc.addImage(iconLogo, 'PNG', 105-21, 277, 42, 4.6)
        }
        doc.setTextColor(this.colors.black)
        doc.setFontStyle("bold")
        doc.setFontSize(11)
        doc.text(intl.get('surfaces.floor'), this.margin, currentY)

        const floorDimensions = helpers.getNumberString(this.roomWidth, 2) + " x " + helpers.getNumberString(this.roomDepth, 2) + " m"
        doc.setTextColor(this.colors.gray)
        doc.setFontStyle("normal")
        doc.setFontSize(10)
        doc.text(floorDimensions, 210-this.margin, currentY, null, null, "right")

        currentY += 5
        const floorArea = this.roomWidth * this.roomDepth
        for (let i=0; i<nbrOfRooms; i++) {
            const absorbantRoom = this.absorbantRooms[i]
            const marginLeft = this.margin + i * (210-2*this.margin) / nbrOfRooms
            this.box(helpers.getRoomName(absorbantRoom), floorArea, this.floorMaterial, null, marginLeft, currentY, (210-2*this.margin) / nbrOfRooms, boxHeight, true)
        }

        // Ceiling
        currentY += 61
        if (currentY > 297 - boxHeight - 20) {
            doc.addPage()
            currentY = 20
            doc.addImage(iconLogo, 'PNG', 105-21, 277, 42, 4.6)
        }
        doc.setTextColor(this.colors.black)
        doc.setFontStyle("bold")
        doc.setFontSize(11)
        doc.text(intl.get('surfaces.ceiling'), this.margin, currentY)

        const ceilingDimensions = helpers.getNumberString(this.roomWidth, 2) + " x " + helpers.getNumberString(this.roomDepth, 2) + " m"
        doc.setTextColor(this.colors.gray)
        doc.setFontStyle("normal")
        doc.setFontSize(10)
        doc.text(ceilingDimensions, 210-this.margin, currentY, null, null, "right")

        currentY += 5
        const ceilingArea = this.roomWidth * this.roomDepth
        for (let i=0; i<nbrOfRooms; i++) {
            const absorbantRoom = this.absorbantRooms[i]
            const marginLeft = this.margin + i * (210-2*this.margin) / nbrOfRooms
            this.box(helpers.getRoomName(absorbantRoom), ceilingArea, this.ceilingMaterial, null, marginLeft, currentY, (210-2*this.margin) / nbrOfRooms, boxHeight, true)
        }


        boxHeight = 30

        // Total absorption area
        currentY += 61
        if (currentY > 297 - boxHeight - 40) {
            doc.addPage()
            currentY = 20
            doc.addImage(iconLogo, 'PNG', 105-21, 277, 42, 4.6)
        }
        doc.setTextColor(this.colors.black)
        doc.setFontStyle("bold")
        doc.setFontSize(11)
        doc.text(intl.get('report.totalAbsorptionArea'), this.margin, currentY)

        currentY += 5.5
        doc.setTextColor(this.colors.gray)
        doc.setFontStyle("normal")
        doc.setFontSize(10)
        const absorptionDescription = doc.splitTextToSize(intl.get('report.totalAbsorptionAreaDescription'), 170)
        doc.text(absorptionDescription, this.margin, currentY)
        if (absorptionDescription.length > 1) {
            currentY += absorptionDescription.length * 3
        }

        currentY += 5
        const absorptionAreaForEmptyRoom = helpers.absorptionAreaForEmptyRoom(this.ceilingMaterial, this.wallMaterial, this.floorMaterial, this.roomWidth, this.roomHeight, this.roomDepth)
        const surfaceAreaForRoom = helpers.surfaceAreaForRoom(this.roomWidth, this.roomHeight, this.roomDepth)
        for (let i=0; i<nbrOfRooms; i++) {
            const absorbantRoom = this.absorbantRooms[i]
            const marginLeft = this.margin + i * (210-2*this.margin) / nbrOfRooms
            let absorptionArea = absorptionAreaForEmptyRoom
            if (!absorbantRoom.empty) {
                absorptionArea += helpers.absorptionAreaForTextiles(absorbantRoom.absorbantWalls)
            }
            const leftLabel = helpers.getNumberString(absorptionArea, 2) + " m²"
            const rightLabel = helpers.getNumberString(surfaceAreaForRoom, 2) + " m²"
            this.barBox(helpers.getRoomName(absorbantRoom), absorptionArea / surfaceAreaForRoom, marginLeft, currentY, (210-2*this.margin) / nbrOfRooms, boxHeight, false, leftLabel, rightLabel)
        }

        // Reverberation time
        currentY += 45
        if (currentY > 297 - boxHeight - 40) {
            doc.addPage()
            currentY = 20
            doc.addImage(iconLogo, 'PNG', 105-21, 277, 42, 4.6)
        }
        doc.setTextColor(this.colors.black)
        doc.setFontStyle("bold")
        doc.setFontSize(11)
        doc.text(intl.get('reverberation.title'), this.margin, currentY)

        currentY += 5.5
        doc.setTextColor(this.colors.gray)
        doc.setFontStyle("normal")
        doc.setFontSize(10)
        const reverberationDescription = doc.splitTextToSize(intl.get('report.reverberationDescription'), 170)
        doc.text(reverberationDescription, this.margin, currentY)
        if (reverberationDescription.length > 1) {
            currentY += reverberationDescription.length * 3
        }

        currentY += 5
        const roomVolume = this.roomWidth * this.roomDepth * this.roomHeight
        const reverberationForEmptyRoom = helpers.reverberationFor(absorptionAreaForEmptyRoom, roomVolume)
        for (let i=0; i<nbrOfRooms; i++) {
            const absorbantRoom = this.absorbantRooms[i]
            const marginLeft = this.margin + i * (210-2*this.margin) / nbrOfRooms
            let reverberation = reverberationForEmptyRoom
            if (!absorbantRoom.empty) {
                const absorptionArea = absorptionAreaForEmptyRoom + helpers.absorptionAreaForTextiles(absorbantRoom.absorbantWalls)
                reverberation = helpers.reverberationFor(absorptionArea, roomVolume)
            }
            const leftLabel = helpers.getNumberString(reverberation, 2) + " s"
            let rightLabel = ""
            const diff = reverberationForEmptyRoom - reverberation
            if (diff > 0) {
                rightLabel = "-" + helpers.getNumberString(reverberationForEmptyRoom - reverberation, 2) + " s"
            }
            this.barBox(helpers.getRoomName(absorbantRoom), reverberation / reverberationForEmptyRoom, marginLeft, currentY, (210-2*this.margin) / nbrOfRooms, boxHeight, true, leftLabel, rightLabel)
        }

        // Sound pressure
        currentY += 45
        if (currentY > 297 - boxHeight - 40) {
            doc.addPage()
            currentY = 20
            doc.addImage(iconLogo, 'PNG', 105-21, 277, 42, 4.6)
        }
        doc.setTextColor(this.colors.black)
        doc.setFontStyle("bold")
        doc.setFontSize(11)
        doc.text(intl.get('decibel.relativeLowering'), this.margin, currentY)

        currentY += 5.5
        doc.setTextColor(this.colors.gray)
        doc.setFontStyle("normal")
        doc.setFontSize(10)
        const audioGainDescription = doc.splitTextToSize(intl.get('report.audioGainDescription'), 170)
        doc.text(audioGainDescription, this.margin, currentY)
        if (audioGainDescription.length > 1) {
            currentY += audioGainDescription.length * 3
        }

        currentY += 5

        for(let i=0; i<nbrOfRooms; i++) {
            const absorbantRoom = this.absorbantRooms[i]
            const marginLeft = this.margin + i * (210-2*this.margin) / nbrOfRooms
            let absorptionArea = absorptionAreaForEmptyRoom
            if (!absorbantRoom.empty) {
                absorptionArea += helpers.absorptionAreaForTextiles(absorbantRoom.absorbantWalls)
            }
            const dBReduction = helpers.noiseLevelReduction(absorptionAreaForEmptyRoom, absorptionArea)
            const audioGain = helpers.dBReductionToGain(dBReduction)
            const leftLabel = ""
            const rightLabel = "-" + helpers.getNumberString(dBReduction, 2) + " dB"
            this.barBox(helpers.getRoomName(absorbantRoom), audioGain, marginLeft, currentY, (210-2*this.margin) / nbrOfRooms, boxHeight, true, leftLabel, rightLabel)

        }

        const storedUser = JSON.parse(sessionStorage.getItem("currentUser"));

        if (storedUser && (storedUser.firstName || storedUser.phoneNumber ||storedUser.email)) {

            currentY += 45
            if (currentY > 297 - boxHeight - 40) {
                doc.addPage()
                currentY = 20
                doc.addImage(iconLogo, 'PNG', 105-21, 277, 42, 4.6)
            }

            doc.setTextColor(this.colors.black)
            doc.setFontStyle("bold")
            doc.setFontSize(11)
            doc.text(intl.get('pdf.contact'), this.margin, currentY)

            if (storedUser.firstName) {
                currentY += 5.5
                doc.setTextColor(this.colors.gray)
                doc.setFontStyle("bold")
                doc.setFontSize(10)
                doc.text(storedUser.firstName + ' ' + storedUser.lastName, this.margin, currentY)
            }

            if (storedUser.phoneNumber) {
                currentY += 5
                doc.setFontStyle("normal")
                doc.text(storedUser.phoneNumber, this.margin, currentY)
            }

            if (storedUser.email) {
                currentY += 5
                doc.setFontStyle("normal")
                doc.text(storedUser.email, this.margin, currentY)
            }
        }

        doc.save(this.filename)
    }

    barBox(header, quotient, xpos, ypos, width, height, numeratorFocus=false, leftLabel, rightLabel) {

        const doc = this.doc
        const padding = 4

        doc.setDrawColor(this.colors.lightgray)

        doc.rect(xpos, ypos, width, height)

        ypos += padding + 2

        doc.setTextColor(this.colors.black)
        doc.setFontSize(8)
        doc.setFontStyle("bold")
        doc.text(header, xpos + padding, ypos)

        ypos += 4
        doc.line(xpos, ypos, xpos+width, ypos)

        ypos += 9
        doc.setTextColor(this.colors.green)
        numeratorFocus && doc.setTextColor(this.colors.gray)
        doc.setFontSize(16)
        doc.setFontStyle("normal")
        doc.text(leftLabel, xpos + padding, ypos)

        doc.setTextColor(this.colors.gray)
        doc.setFontSize(10)
        if (numeratorFocus) {
            doc.setTextColor(this.colors.green)
            doc.setFontSize(16)
        }
        doc.text(rightLabel, xpos + width - padding, ypos, "right")

        ypos += 4
        doc.setFillColor(this.colors.lightGreen)
        numeratorFocus && doc.setFillColor(this.colors.mediumGray)
        const leftBarWidth = quotient * (width - 2 * padding)
        doc.rect(xpos + padding, ypos, leftBarWidth, 2.5, 'F')
        doc.setFillColor(this.colors.mediumGray)
        numeratorFocus && doc.setFillColor(this.colors.lightGreen)
        const rightBarWidth = width - 2 * padding - leftBarWidth
        doc.rect(xpos + padding + leftBarWidth, ypos, rightBarWidth, 2.5, 'F')
    }



    box(header, area, material, layer, xpos, ypos, width, height, isCompact) {

        const doc = this.doc
        const padding = 4

        doc.setDrawColor(this.colors.lightgray)
        doc.rect(xpos, ypos, width, height)

        ypos += padding + 2

        doc.setTextColor(this.colors.black)
        doc.setFontSize(8)
        doc.setFontStyle("bold")
        doc.text(header, xpos+padding, ypos)

        ypos += 4
        doc.line(xpos, ypos, xpos+width, ypos)

        ypos += 6
        let name = intl.get(material.name + '.name')

        if (layer && layer.product) {
            name = layer.product.name

            if (layer.colorIndex >= 0 && layer.product.colors.length > 0) {
                name += ', ' + layer.product.colors[layer.colorIndex]
            }


        }
        doc.setTextColor(this.colors.black)
        doc.setFontSize(10)
        doc.setFontStyle("normal")
        doc.text(name, xpos+padding, ypos)

        ypos += 6
        if (!layer || !layer.product) {
            let alpha = this.wallMaterial.absorptionCoefficient
            alpha = helpers.getNumberString(parseFloat(alpha), 2)
            alpha = "aw = " + alpha
            if (this.wallMaterial.shapeIndicator) {
                alpha += " (" + this.wallMaterial.shapeIndicator + ")"
            }
            doc.setTextColor(this.colors.gray)
            doc.setFontSize(10)
            doc.setFontStyle("normal")
            doc.text(alpha, xpos+padding, ypos)

            ypos+= 4
            !isCompact && (ypos += 28)
            doc.line(xpos + padding, ypos, xpos + width - padding, ypos)

            ypos += 10
            const absorptionArea = area * material.absorptionCoefficient
            const absorptionAreaString = intl.get('general.squareMeter', {area: helpers.getNumberString(absorptionArea, 2)})
            doc.setFontSize(16)
            doc.text(absorptionAreaString, xpos + padding, ypos)

            ypos+= 6
            doc.setFontSize(10)
            doc.text(intl.get('report.absorptionArea'), xpos + padding, ypos)
        }
        else if (layer && layer.product) {
            const productVariant = helpers.productVariantForLayer(layer)
            let productClass = intl.get('report.class') + ' ' + productVariant.absorptionClass
            doc.setTextColor(this.colors.gray)
            doc.setFontSize(10)
            doc.setFontStyle("normal")
            doc.text(productClass, xpos+padding, ypos)

            ypos += 6
            let alpha = productVariant.absorptionCoefficient
            let alphaStr = 'aw = '
            alphaStr += helpers.getNumberString(parseFloat(alpha), 2)
            if (productVariant.shapeIndicator) {
                alphaStr += ' (' + productVariant.shapeIndicator + ')'
            }
            doc.text(alphaStr, xpos+padding, ypos)

            ypos+= 4
            doc.line(xpos + padding, ypos, xpos + width - padding, ypos)

            const image = helpers.getTextileImage(layer)
            if (image) {
                const imageData = new Image()
                imageData.src = image
                doc.addImage(imageData, 'JPEG', xpos+width-padding-15, ypos-16-2.7, 15, 15, imageData.src, 'NONE')
            }

            ypos += 6
            const layerWidthString = intl.get('general.width') + ': ' + helpers.getNumberString(layer.width, 2) + ' m'
            doc.text(layerWidthString, xpos + padding, ypos)

            ypos += 6
            const layerHeightString = intl.get('general.height') + ': ' + helpers.getNumberString(layer.height, 2) + ' m'
            doc.text(layerHeightString, xpos + padding, ypos)

            ypos += 6
            let implementation = ''
            layer.folded ?
                implementation = intl.get('report.implementationFolded')
                :
                implementation = intl.get('report.implementationFlat')
            implementation += ", "
            implementation += intl.get('report.implementationDistance', {distance: layer.distance})
            doc.text(implementation, xpos + padding, ypos)

            ypos+= 4
            doc.line(xpos + padding, ypos, xpos + width - padding, ypos)

            ypos += 10
            const absorptionArea = helpers.absorptionAreaForLayer(layer)
            const absorptionAreaString = intl.get('general.squareMeter', {area: helpers.getNumberString(absorptionArea, 2)})
            doc.setFontSize(16)
            doc.text(absorptionAreaString, xpos + padding, ypos)

            ypos+= 6
            doc.setFontSize(10)
            doc.text(intl.get('report.absorptionArea'), xpos + padding, ypos)


        }
    }
}

export default PDFGenerator
